import {
  PIX_KEY_TYPE_VALUES,
  pixKeyTypes,
} from '../constants/pixKeyTypeConstants';
import { getCnaeOptions } from '../constants/cnaeConstants';
import { FORM_MODES } from '../constants/formModeConstants';
import { formatCNPJ, formatCPF } from '@wareclouds/frontend-common';
import { initialValues } from '../schemas/bankAccountSchemaBr';
import { formatBrPixPhone } from '../formatBrPixPhone';

const formatPixKeyValue = (pixKey, pixType) => {
  if (!pixKey) return '';
  if (pixType === PIX_KEY_TYPE_VALUES.CPF) return formatCPF(pixKey);
  if (pixType === PIX_KEY_TYPE_VALUES.CNPJ) return formatCNPJ(pixKey);
  if (pixType === PIX_KEY_TYPE_VALUES.PHONE) return formatBrPixPhone(pixKey);
  return pixKey;
};

export const mapBankAccountFieldsBr = ({
  accounts = {},
  bankListData = [],
  formMode = FORM_MODES.CNPJ,
  t,
}) => {
  const accountKey = formMode === FORM_MODES.CPF ? 'CPF' : 'CNPJ';
  const account = accounts[accountKey];

  if (!account) {
    return { ...initialValues, formMode };
  }

  const accountData = account.account_data || {};

  const bankFound = bankListData.find((b) => b.value === account.id_bank);
  const accountTypeFound = bankFound?.accountTypes?.find(
    (at) => at.value === accountData.account_type
  );
  const pixKeyTypeFound = pixKeyTypes.find(
    (type) => type.value === accountData.pix_type
  );
  const cnaeOptions = getCnaeOptions(t);
  const cnaeFound = cnaeOptions.find(
    (option) => option.value === accountData.cnae
  );

  const rawDocument =
    formMode === FORM_MODES.CPF
      ? accountData.cpf || ''
      : accountData.cnpj || '';

  return {
    formMode,
    document:
      formMode === FORM_MODES.CPF
        ? formatCPF(rawDocument)
        : formatCNPJ(rawDocument),
    legalName: accountData.company_name || '',
    fiscalAddress: accountData.fiscal_address || '',
    cnae: cnaeFound || null,
    bank: bankFound || null,
    accountType: accountTypeFound || null,
    agencyCode: accountData.agency_code || '',
    accountNumber: accountData.account_number || '',
    pixKeyType: pixKeyTypeFound || null,
    pixKey: formatPixKeyValue(accountData.pix_key, pixKeyTypeFound?.value),
  };
};
